// module.foobar



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/__tests__/test_root/module.foobar
// module id = 1506
// module chunks = 0